export default '/static/frontend/ReachDigital/12gobiking/dist/assets/rembours-b1ec6b27.svg'